export default "__VITE_ASSET__nprpwjmD__"